// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedAnalyzeSubstract_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.9999 7.99902C11.1339 7.99902 7.99988 11.133 7.99988 14.999C7.99988 18.865 11.1339 21.999 14.9999 21.999C18.8659 21.999 21.9999 18.865 21.9999 14.999C21.9999 11.133 18.8659 7.99902 14.9999 7.99902ZM14.9999 5.99902C10.0293 5.99902 5.99988 10.0285 5.99988 14.999C5.99988 19.9696 10.0293 23.999 14.9999 23.999C19.9704 23.999 23.9999 19.9696 23.9999 14.999C23.9999 10.0285 19.9704 5.99902 14.9999 5.99902Z" class="svg-bg"/>
  <path d="M2 9C2 5.13401 5.13401 2 9 2C11.7943 2 14.2062 3.63732 15.3287 6.00492C16.1209 6.03337 16.8869 6.1642 17.6141 6.38457C16.4937 2.68957 13.0609 0 9 0C4.02944 0 0 4.02944 0 9C0 13.0614 2.69017 16.4944 6.3858 17.6145C6.16532 16.8873 6.03438 16.1213 6.00582 15.3291C3.63774 14.2069 2 11.7947 2 9Z" class="svg-bg"/>
  <path d="M9.38144 7.96773C8.85942 8.3854 8.38493 8.85999 7.96738 9.38209L2.63461 4.04933 4.04883 2.63512 9.38144 7.96773ZM6.17121 13.2424.513671 7.58488 1.92788 6.17067 6.87667 11.1195C6.55783 11.7859 6.31857 12.4976 6.17121 13.2424ZM13.2414 6.17073C12.4967 6.31822 11.7851 6.5576 11.1188 6.87653L6.08895 1.84668 7.50316.432466 13.2414 6.17073Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedAnalyzeSubstract is a generated icon component.
 */
let IconMedAnalyzeSubstract = IconMedAnalyzeSubstract_1 = class IconMedAnalyzeSubstract extends IconBaseElement {
    render() {
        return html `${IconMedAnalyzeSubstract_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedAnalyzeSubstract.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedAnalyzeSubstract = IconMedAnalyzeSubstract_1 = __decorate([
    customElement('zui-icon-med-analyze-substract')
], IconMedAnalyzeSubstract);
export { IconMedAnalyzeSubstract };
